import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "relative" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "absolute top-0 w-full" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "flex w-full space-x-4" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "w-11/12 skeleton-unit" }),
      /*#__PURE__*/_createElementVNode("div", { class: "w-1/12 rounded-full skeleton-unit" })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "opacity-0" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "flex items-center" }, [
      /*#__PURE__*/_createElementVNode("h5", null, " "),
      /*#__PURE__*/_createElementVNode("div", { class: "flex ml-2 space-x-1" }),
      /*#__PURE__*/_createElementVNode("div", { class: "my-auto ml-4 cursor-default chip chip-sm" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "flex items-center" }, " ")
      ])
    ])
  ])
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "relative" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "absolute top-0 w-full" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "w-full h-4 my-2 skeleton-unit" }),
    /*#__PURE__*/_createElementVNode("div", { class: "w-full h-4 skeleton-unit" })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "relative h-12 overflow-y-hidden opacity-0" }, [
    /*#__PURE__*/_createElementVNode("div", {
      style: {"display":"-webkit-box","-webkit-line-clamp":"2","-webkit-box-orient":"vertical","overflow":"hidden"},
      class: "w-11/12 overflow-x-hidden overflow-ellipsis text-muted"
    }, "   ")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, {
    size: 'sm',
    hoverable: false
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    body: _withCtx(() => [
      _hoisted_2
    ]),
    _: 1
  }))
}